import {pageInfo, upoladImg,initPage, initUpdate,exportData,updateToBUpdate,downtemplate,initOrderNo,arrivedSubmit,initMivDate,updateToBFirstArrivalTime,updateToBIntCompletionTime,updateToBIntDelayReson,messageImport, confirmStatusUpdateImport} from './../api';
import {selectCarrier, selectDelayResonCode,mdBrandList} from '../../../../api'
import { Message } from 'element-ui';
const statusUpdate = {
  namespaced: true,
  state: {
    total:0,
    pageResp:null,
    initPageObj: null,
    initUpdateObj: null,
    exportObj:null,
    templateObj:null,
    statusUpdateResp:null,
    orderNoObj:null,
    mivInfoObj:null,
    uploadUrlData: upoladImg,
    carrierObj:null,
    delayResonCodeObj:null,
    arrivedSubmitObj:null,
    exportFirstArrivalTimeObj:null,
    exportIntCompletionTimeObj:null,
    exportDelayResonObj:null,
    brandObj:null,
    messageImportObj: null,
    confirmStatusUpdateImportObj: null,
  },
  mutations: {

    PAGE_INFO(state,data){
      state.total = data.total;
      state.pageResp = data.obj || [];
    },
    INIT_PAGE(state,data) {
      state.initPageObj = data.obj || {};
    },
    INIT_UPDATE(state,data) {
      state.initUpdateObj = data.obj || {};
    },
    EXPORT_DATA(state, data) {
      state.exportObj = data;
    },
    UPLOAD_DATA(state, data) {
      state.statusUpdateResp = data;
    },
    UPLOAD_DATA_FIRSTARRIVAL_TIME(state, data){
      state.exportFirstArrivalTimeObj = data;
    },
    UPLOAD_DATA_COMPLETION_TIME(state, data){
      state.exportIntCompletionTimeObj = data;
    },
    UPLOAD_DATA_DELAY_RESON(state, data){
      state.exportDelayResonObj = data;
    },
    ARRIVE_SUBMIT_DATA(state, resp){
      state.arrivedSubmitObj = resp || [];
    },
    DOWN_LOAD_TEMPLATE(state, data) {
      state.templateObj = data;
    },
    SELECT_CARRIER(state, resp){
      state.carrierObj = resp.obj || [];
    },
    SELECT_DELAYRESONCODE(state, resp){
      state.delayResonCodeObj = resp.obj || [];
    },
    ORDER_NO(state,data){
      state.orderNoObj = (data.obj || []).map((item, index) => {
        console.log(item.bdOrderLogisticsVOS,'===BdOrderLogisticsVOS');
        return {
          ...item,
          lable: item.planArriveTime +  '【' + item.orderNo +'】',
          bdOrderLogisticsVOS: item.bdOrderLogisticsVOS.map((subItem, subIndex)=>{

            if(subIndex==0) {
              return {
                ...subItem,
                color: '#26654D'
              }
            }
            return subItem;
          })
        }
      });
    },
    MIV_DATE(state,data){
      state.mivInfoObj = data.obj || []
    },
    SELECT_BRAND(state, resp){
      state.brandObj = resp.obj || [];
    },
    MESSAGE_IMPORT(state, resp){
      state.messageImportObj = resp;
    },
    CONFIRM_STATUS_UPDATE_IMPORT(state, resp){
      state.confirmStatusUpdateImportObj = resp;
    }
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj){
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    //初始化页面事件
    async initPage({commit}, obj){
      let resp = await initPage(obj);
      commit('INIT_PAGE', resp);
    },
    //初始化更新对象事件
    async initUpdate({commit}, obj){
      let resp = await initUpdate(obj);
      commit('INIT_UPDATE', resp);
    },
    async initOrderNo({commit}, obj){
      let resp = await initOrderNo(obj);
      commit('ORDER_NO', resp);
    },
    async initMivDate({commit}, obj){
      let resp = await initMivDate(obj);
      commit('MIV_DATE', resp);
    },
    //导出
    async exportData({ commit }, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
    //物流商
    async ListCarrierSelect({ commit }, obj) {
      let resp = await selectCarrier(obj);
      commit('SELECT_CARRIER', resp);
    },
    //延迟原因
    async ListDelayResonCodeSelect({ commit }, obj) {
      let resp = await selectDelayResonCode(obj);
      commit('SELECT_DELAYRESONCODE', resp);
    },
    async arrivedSubmit({ commit }, obj) {
      let resp = await arrivedSubmit(obj);
      commit('ARRIVE_SUBMIT_DATA', resp);
    },
    //在途导入数据
    async updateToBUpdate({ commit }, obj) {
      let resp = await updateToBUpdate(obj);
      commit('UPLOAD_DATA', resp);
    },

    //首次时间导入数据
    async updateToBFirstArrivalTime({ commit }, obj) {
      let resp = await updateToBFirstArrivalTime(obj);
      commit('UPLOAD_DATA_FIRSTARRIVAL_TIME', resp);
    },
    //完成时间导入
    async updateToBIntCompletionTime({ commit }, obj) {
      let resp = await updateToBIntCompletionTime(obj);
      commit('UPLOAD_DATA_COMPLETION_TIME', resp);
    },
    //延迟原因导入
    async updateToBDelayReson({ commit }, obj) {
      let resp = await updateToBIntDelayReson(obj);
      commit('UPLOAD_DATA_DELAY_RESON', resp);
    },
    //品牌
    async mdBrandList({ commit }, obj) {
      let resp = await mdBrandList(obj);
      commit('SELECT_BRAND', resp);
    },
    //下载模板
    async template({ commit }, obj) {
      let resp = await downtemplate(obj);
      commit('DOWN_LOAD_TEMPLATE', resp);
    },
    //信息导入
    async messageImport({commit}, obj) {
      let resp = await messageImport(obj);
      commit('MESSAGE_IMPORT', resp);
    },
    //确认状态修改导入
    async confirmStatusUpdateImport({commit}, obj) {
      let resp = await confirmStatusUpdateImport(obj);
      commit('CONFIRM_STATUS_UPDATE_IMPORT', resp);
    }
  }
}
export default statusUpdate



// WEBPACK FOOTER //
// ./src/page/toBUpdate/statusUpdate/store/statusUpdate.store.js